import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { HomeworkDetailView } from '@/views/homeworks/homework-detail-view.tsx';

// Homework 详情（学生：提交面板 + 历史；教师：提交列表）。
export const Route = createFileRoute('/_learner/homeworks_/$id/')({
  component: HomeworkDetailPage,
});

function HomeworkDetailPage() {
  const { id } = useParams({ from: '/_learner/homeworks_/$id/' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <HomeworkDetailView id={id} user={user} />;
}
